export default "__VITE_ASSET__BnHrbzbc__"